import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
// //Import Scrollbar
import SimpleBar from "simplebar-react"
// MetisMenu
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
//i18n
import { withTranslation } from "react-i18next"
import { FaRegFileAlt } from "react-icons/fa";

const SidebarContent = props => {
  const [activeMenu, setActiveMenu] = useState('')
  const [activeSubMenu, setActiveSubMenu] = useState('frx-home-carousel-banners')
  const [AllPermission, setAllPermission] = useState({})

  const getAllPermissions = () => {
    setTimeout(async () => {
      let permissions = await localStorage.getItem("userPermissions")
      setAllPermission(JSON.parse(permissions))
      // let role= await localStorage.getItem("userRole")
      // // setUserRole(role)
    }, 1000);
  }
  useEffect(() => {
    getAllPermissions()
  }, [])

  const handleActiveMenu = (str) => {
    setActiveMenu(str)
  }

  const handleActiveSubMenu = (str) => {
    setActiveSubMenu(str)
  }
  return (
    <React.Fragment>

      <SimpleBar style={{ maxHeight: "100%" }} className="sidebar-menu-scroll">
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {/* manage content */}
            <li className="menu-title">Manage Content</li>
            {AllPermission?.carousel &&
              <li>
                <Link onClick={(e) => { handleActiveMenu("carousel-banners") }} className={activeMenu == "carousel-banners" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                
                <i className=""><FaRegFileAlt size={16} /></i>
                  <span>{props.t("Carousel Banners")}</span>
                </Link>
                {activeMenu == "carousel-banners" &&
                  <ul className="sub-menu">
                    <li>
                      <Link to="/carousel-banners/frx-home" onClick={(e) => { handleActiveSubMenu("frx-home-carousel-banners") }} className={activeSubMenu == "frx-home-carousel-banners" ? "mm-active" : ""}>{props.t("FRx Home")}</Link>
                    </li>
                    <li>
                      <Link to="/carousel-banners/rewards" onClick={(e) => { handleActiveSubMenu("frx-home-reward-banners") }} className={activeSubMenu == "frx-home-reward-banners" ? "mm-active" : ""} >{props.t("Rewards")}</Link>
                    </li>
                  </ul>
                }
              </li>}
            {AllPermission?.banners && <li>
              <Link to={"/marketing-banners/splash-screens"} onClick={(e) => { handleActiveMenu("splash-banners") }} className={activeMenu == "splash-banners" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                <i className=""><FaRegFileAlt size={16} /></i>
                <span>{props.t("Splash Banners")}</span>
              </Link>
            </li>}
            {AllPermission?.banners && <li>
              <Link to={"/marketing-banners/mini-banners"} onClick={(e) => { handleActiveMenu("mini-banners") }} className={activeMenu == "mini-banners" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                <i className=""><FaRegFileAlt size={16} /></i>
                <span>{props.t("Mini Banners")}</span>
              </Link>
            </li>}
            {AllPermission?.tiles_banners &&
              <li>
                <Link onClick={(e) => { handleActiveMenu("single-banners") }} className={activeMenu == "single-banners" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                  <i className=""><FaRegFileAlt size={16} /></i>
                  <span>{props.t("Single Banners")}</span>
                </Link>
                {activeMenu == "single-banners" &&
                  <ul className="sub-menu">
                    <li>
                      <Link to="/single-banners/frx-home-single-banners" onClick={(e) => { handleActiveSubMenu("frx-home-single-banners") }} className={activeSubMenu == "frx-home-single-banners" ? "mm-active" : ""}>{props.t("FRx Home")}</Link>
                    </li>
                    <li>
                      <Link to="/single-banners/rewards-single" onClick={(e) => { handleActiveSubMenu("rewards-single") }} className={activeSubMenu == "rewards-single" ? "mm-active" : ""}>{props.t("Rewards")}</Link>
                    </li>

                  </ul>}
              </li>}
            {AllPermission?.marketplacebanners && <li>
              <Link onClick={(e) => { handleActiveMenu("marketplace-banners") }} className={activeMenu == "marketplace-banners" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                <i className=""><FaRegFileAlt size={16} /></i>
                <span>{props.t("MarketPlace Banners")}</span>
              </Link>
              {activeMenu == "marketplace-banners" &&
                <ul className="sub-menu">
                  <li>
                    <Link to="/market-place/grab-food" onClick={(e) => { handleActiveSubMenu("mp-grab") }} className={activeSubMenu == "mp-grab" ? "mm-active" : ""} >
                      <span>{props.t("Grab")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/market-place/grab-promo" onClick={(e) => { handleActiveSubMenu("mp-grab-promo") }} className={activeSubMenu == "mp-grab-promo" ? "mm-active" : ""} >
                      <span>{props.t("Grab Promo")}</span>
                    </Link>
                  </li>
                </ul>
              }
            </li>}
            {AllPermission?.ribbons && <li>
              <Link to="/ribbons" onClick={(e) => { handleActiveMenu("ribbon") }} className={activeMenu == "ribbon" ? "mm-active" : ""} >
                <i className=""><FaRegFileAlt size={16} /></i>
                <span>{props.t("Ribbon")}</span>
              </Link>
            </li>}
            {(AllPermission?.homepagecards || AllPermission?.referfriend) &&
              <li>
                <Link onClick={(e) => { handleActiveMenu("cards-section") }} className={activeMenu == "cards-section" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                  <i className=""><FaRegFileAlt size={16} /></i>
                  <span>{props.t("Cards")}</span>
                </Link>
                {activeMenu == "cards-section" &&
                  <ul className="sub-menu">
                    {AllPermission?.homepagecards && <li>
                      <Link to="/homepage-cards" onClick={(e) => { handleActiveSubMenu("homepage-cards") }} className={activeSubMenu == "homepage-cards" ? "mm-active" : ""} >
                        <span>{props.t("Homepage Card")}</span>
                      </Link>
                    </li>}
                    {AllPermission?.referfriend && <li>
                      <Link to="/refer-friend-cards" onClick={(e) => { handleActiveSubMenu("refer-friend-cards") }} className={activeSubMenu == "refer-friend-cards" ? "mm-active" : ""} >
                        <span>{props.t("Refer a Friend Card")}</span>
                      </Link>
                    </li>}
                  </ul>
                }
              </li>}
            {AllPermission?.modelmessage && <li>
              <Link onClick={(e) => { handleActiveMenu("modal-messages") }} className={activeMenu == "modal-messages" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                <i className=""><FaRegFileAlt size={16} /></i>
                <span>{props.t("Modal Messages")}</span>
              </Link>
              {activeMenu == "modal-messages" &&
                <ul className="sub-menu">
                  {AllPermission?.modelmessage && <li>
                    <Link to="/paymentexit" onClick={(e) => { handleActiveSubMenu("payment-exit") }} className={activeSubMenu == "payment-exit" ? "mm-active" : ""} >
                      <span>{props.t("Payment Exit")}</span>
                    </Link>
                  </li>}
                  {AllPermission?.modelmessage && <li>
                    <Link to="/grabfood" onClick={(e) => { handleActiveSubMenu("grab-food") }} className={activeSubMenu == "grab-food" ? "mm-active" : ""} >
                      <span>{props.t("GrabFood")}</span>
                    </Link>
                  </li>}{AllPermission?.modelmessage && <li>
                    <Link to="/grabmart" onClick={(e) => { handleActiveSubMenu("grab-mart") }} className={activeSubMenu == "grab-mart" ? "mm-active" : ""} >
                      <span>{props.t("GrabMart")}</span>
                    </Link>
                  </li>}{AllPermission?.modelmessage && <li>
                    <Link to="/grabpay" onClick={(e) => { handleActiveSubMenu("grab-pay") }} className={activeSubMenu == "grab-pay" ? "mm-active" : ""} >
                      <span>{props.t("GrabPay")}</span>
                    </Link>
                  </li>}
                  {AllPermission?.modelmessage && <li>
                    <Link to="/creditcard" onClick={(e) => { handleActiveSubMenu("credit-card") }} className={activeSubMenu == "credit-card" ? "mm-active" : ""} >
                      <span>{props.t("Credit Card")}</span>
                    </Link>
                  </li>}
                  {AllPermission?.modelmessage && <li>
                    <Link to="/ocbcdigital" onClick={(e) => { handleActiveSubMenu("ocbc-digital") }} className={activeSubMenu == "ocbc-digital" ? "mm-active" : ""} >
                      <span>{props.t("OCBC Digital")}</span>
                    </Link>
                  </li>}
                  {AllPermission?.modelmessage && <li>
                    <Link to="/paylater" onClick={(e) => { handleActiveSubMenu("paylater") }} className={activeSubMenu == "paylater" ? "mm-active" : ""} >
                      <span>{props.t("PayLater")}</span>
                    </Link>
                  </li>}
                  {AllPermission?.modelmessage && <li>
                    <Link to="/lifesg" onClick={(e) => { handleActiveSubMenu("lifesg") }} className={activeSubMenu == "lifesg" ? "mm-active" : ""} >
                      <span>{props.t("LifeSG")}</span>
                    </Link>
                  </li>}
                  {AllPermission?.modelmessage && <li>
                    <Link to="/paynowqr" onClick={(e) => { handleActiveSubMenu("paynowqr") }} className={activeSubMenu == "paynowqr" ? "mm-active" : ""} >
                      <span>{props.t("PayNow")}</span>
                    </Link>
                  </li>}
                  {AllPermission?.modelmessage && <li>
                    <Link to="/rewardsmodal" onClick={(e) => { handleActiveSubMenu("rewards-modal") }} className={activeSubMenu == "rewards-modal" ? "mm-active" : ""} >
                      <span>{props.t("Rewards Modal")}</span>
                    </Link>
                  </li>}
                </ul>
              }
            </li>}
            {AllPermission?.moreSection &&
              <li>
                <Link onClick={(e) => { handleActiveMenu("more-section") }} className={activeMenu == "more-section" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                  <i className=""><FaRegFileAlt size={16} /></i>
                  <span>{props.t("More")}</span>
                </Link>
                {activeMenu == "more-section" &&
                  <ul className="sub-menu">
                    {AllPermission?.giftcard && <li>
                      <Link to="/gift-cards" onClick={(e) => { handleActiveSubMenu("gift-cards") }} className={activeSubMenu == "gift-cards" ? "mm-active" : ""} >
                        <span>{props.t("Add Gift Card")}</span>
                      </Link>
                    </li>}
                    {AllPermission?.partnerrewards && <li>
                      <Link to="/partner-reward" onClick={(e) => { handleActiveSubMenu("partner-reward") }} className={activeSubMenu == "partner-reward" ? "mm-active" : ""} >
                        <span>{props.t("Partner Rewards")}</span>
                      </Link>
                    </li>}
                    {AllPermission?.qrcodenotes && <li>
                      <Link to="/qr-code-note" onClick={(e) => { handleActiveSubMenu("qr-code-note") }} className={activeSubMenu == "qr-code-note" ? "mm-active" : ""} >
                        <span>{props.t("QR-Code Note")}</span>
                      </Link>
                    </li>}
                    {AllPermission?.cms && <li>
                      <Link to="/payment-sliders" onClick={(e) => { handleActiveSubMenu("payment-sliders") }} className={activeSubMenu == "payment-sliders" ? "mm-active" : ""} >
                        <span>{props.t("Payment Sliders")}</span>
                      </Link>
                    </li>}
                  </ul>
                }
              </li>}
              {AllPermission?.referfriend &&
              <li>
                <Link onClick={(e) => { handleActiveMenu("refer-a-friend-section") }} className={activeMenu == "refer-a-friend-section" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                  <i className=""><FaRegFileAlt size={16} /></i>
                  <span>{props.t("Refer a Friend")}</span>
                </Link>
                {activeMenu == "refer-a-friend-section" &&
                  <ul className="sub-menu">
                    <li>
                      <Link to="/refer-friend-widgets" onClick={(e) => { handleActiveSubMenu("refer-friend-widgets") }} className={activeSubMenu == "refer-friend-widgets" ? "mm-active" : ""} >
                        <span>{props.t("Refer Widgets")}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/refer-link" onClick={(e) => { handleActiveSubMenu("refer-link") }} className={activeSubMenu == "refer-link" ? "mm-active" : ""} >
                        <span>{props.t("Refer Link Text")}</span>
                      </Link>
                    </li>
                  </ul>
                }
              </li>}
            {AllPermission?.othersSection && <li>
              <Link onClick={(e) => { handleActiveMenu("others-section"); handleActiveSubMenu("others-section") }} className={activeMenu == "others-section" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                <i className=""><FaRegFileAlt size={16} /></i>
                <span>{props.t("Others")}</span>
              </Link>
              {activeMenu == "others-section" && <ul className="sub-menu">
                {AllPermission?.settings && <li>
                  <Link to="/settings" onClick={(e) => { handleActiveSubMenu("settings") }} className={activeSubMenu == "settings" ? "mm-active" : ""} >
                    <span>{props.t("Settings")}</span>
                  </Link>
                </li>}
                {AllPermission?.sidedrawer &&
                  <li>
                    <Link to="/sidedrawer" onClick={(e) => { handleActiveSubMenu("sidedrawer") }} className={activeSubMenu == "sidedrawer" ? "mm-active" : ""} >
                      <span>{props.t("Side Drawer")}</span>
                    </Link>
                  </li>}
                {AllPermission
                  ?.deeplink && <li>
                    <Link to="/deeplink-navigation" onClick={(e) => { handleActiveSubMenu("deeplink-navigation") }} className={activeSubMenu == "deeplink-navigation" ? "mm-active" : ""} >
                      <span>{props.t("Deeplink Navigation")}</span>
                    </Link>
                  </li>}
                {AllPermission?.appversions && <li>
                  <Link to="/app-version" onClick={(e) => { handleActiveSubMenu("app-version") }} className={activeSubMenu == "app-version" ? "mm-active" : ""} >
                    <span>{props.t("App Versions")}</span>
                  </Link>
                </li>}
                {AllPermission?.paymentmethods && <li>
                  <Link to="/payments" onClick={(e) => { handleActiveSubMenu("payment-methods") }} className={activeSubMenu == "payment-methods" ? "mm-active" : ""} >
                    <span>{props.t("Payment Method")}</span>
                  </Link>
                </li>}
                {AllPermission?.faqs && <li>
                  <Link to="/faqs" onClick={(e) => { handleActiveSubMenu("member-spend-faqs") }} className={activeSubMenu == "member-spend-faqs" ? "mm-active" : ""} >
                    <span>{props.t("Member Spend FAQ")}</span>
                  </Link>
                </li>}
                {AllPermission?.othersSection && <li>
                  <Link to="/export-aem-stores" onClick={(e) => { handleActiveSubMenu("export-aem-stores") }} className={activeSubMenu == "export-aem-stores" ? "mm-active" : ""} >
                    <span>{props.t("Export AEM Stores")}</span>
                  </Link>
                </li>}
              </ul>}
            </li>}
            {AllPermission?.othersSection && <li>
              <Link to="/tools" onClick={(e) => { handleActiveMenu("tools") }} className={activeMenu == "tools" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                <i className=""><FaRegFileAlt size={16} /></i>
                <span>{props.t("Tools")}</span>
              </Link>
            </li>}
            {/* manage content */}
            {AllPermission?.campaigns &&
              <>
                <li className="menu-title">Coupon Codes</li>
                <li>
                  <Link to="/campaign-dgc" onClick={(e) => { handleActiveMenu("campaign-dgc") }} className={activeMenu == "campaign-dgc" ? "mm-active" : ""} style={{ cursor: "pointer" }}>
                    <i className=""><FaRegFileAlt size={16} /></i>
                    <span>{props.t("Campaigns DGC")}</span>
                  </Link>
                </li>
              </>}
            <>
              {(AllPermission?.usersmanagement || AllPermission?.permissions || AllPermission?.rolesmanagement) && <li className="menu-title">USERS</li>}
              {AllPermission?.usersmanagement && <li>
                <Link to="/manage-users" onClick={(e) => { handleActiveMenu("manage-users") }} className={activeMenu == "manage-users" ? "mm-active" : ""} >
                <i className=""><FaRegFileAlt size={16} /></i>
                  <span>{props.t("Manage Users")}</span>
                </Link>
              </li>}
              {AllPermission?.permissions && <li>
                <Link to="/permissions" onClick={(e) => { handleActiveMenu("permissions") }} className={activeMenu == "permissions" ? "mm-active" : ""} >
                <i className=""><FaRegFileAlt size={16} /></i>
                  <span>{props.t("Permissions")}</span>
                </Link>
              </li>}
              {AllPermission?.rolesmanagement && <li>
                <Link to="/roles" onClick={(e) => { handleActiveMenu("roles") }} className={activeMenu == "roles" ? "mm-active" : ""}>
                <i className=""><FaRegFileAlt size={16} /></i>
                  <span>{props.t("Roles")}</span>
                </Link>
              </li>}
            </>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment >
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))




